import { ChangeDetectionStrategy, Component, computed, inject, input, Signal } from "@angular/core";
import { OrderShipment } from "src/app/models/order-shipment";
import { OrderUtilityService } from "src/app/services";

@Component({
  selector: 'insight-order-shipment-details-progress',
  templateUrl: './order-shipment-details-progress.component.html',
  styleUrls: ['./order-shipment-details-progress.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [],
  imports: [],
  standalone: true
})
export class OrderShipmentDetailsProgressComponent {
  public readonly orderUtilityService = inject(OrderUtilityService);
  public readonly orderShipment = input.required<OrderShipment>();

  public readonly isShipmentCancelled: Signal<boolean> = computed(() => {
    return this.orderUtilityService.isShipmentCancelled(this.orderShipment());
  });

  public readonly isAllShipmentLinesCancelled: Signal<boolean> = computed(() => {
    return this.orderShipment().allLinesAreCancelled;
  });
}
